import O1HD from "../../../../engines/gameEngine";
import PageView = cc.PageView;
import WeChatMain from "./WeChatMain";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatHousePrefab extends cc.Component {

    @property({type:cc.PageView,displayName:"pageView"})
    pageView : cc.PageView = null;
    @property({type:cc.Node,displayName:"微信iconNode"})
    weChatIconNode : cc.Node = null;
    @property({type:cc.Node,displayName:"朋友圈Node"})
    pyqIconNode : cc.Node = null;
    @property(WeChatMain)
    weChatMain : WeChatMain = null;

    //当前下标
    private _currPageIndex : number = 0;


    onLoad(): void {
        this.pageView.setCurrentPageIndex(0);
        this.pageView.node.on("page-turning" , this.pageTurning , this );
    }

    start(){

    }

    bindData(){
        this.weChatMain.bindManager(NormalGameManager._instance.weChatManager);
    }

    /**
     * 分页
     */
    pageTurning( pageView: PageView ){
        //pageView.getCurrentPageIndex()
    }

    /**
     * 微信聊天
     */
    onBtnWeChat(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.weChatIconNode.getChildByName("lightNode").active = true;
        this.weChatIconNode.getChildByName("normalNode").active = false;
        this.pyqIconNode.getChildByName("lightNode").active = false;
        this.pyqIconNode.getChildByName("normalNode").active = true;
        this.pageView.setCurrentPageIndex( 0 );
    }

    /**
     * 朋友圈
     */
    onBtnPyq(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
        return;
        this.weChatIconNode.getChildByName("lightNode").active = false;
        this.weChatIconNode.getChildByName("normalNode").active = true;
        this.pyqIconNode.getChildByName("lightNode").active = true;
        this.pyqIconNode.getChildByName("normalNode").active = false;
        this.pageView.setCurrentPageIndex( 1 );
    }

    onBtnBack(){
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onDisable(): void {
        O1HD.emit("normalMode.onBackNormal","WeChat");
    }


}
